import getFormattedDollarPrice from 'shared/getters/getFormattedDollarPrice';

export function formatLowestPrice(price: number | undefined, widgetStepPricePre: string) {
  if (!price) {
    return undefined;
  }

  return `${widgetStepPricePre} ${getFormattedDollarPrice(price)}`;
}

export function shouldShowAsLowPrice(
  variant: { price: number; asLowPrice: number },
  discounts: { discountPercent?: number; recurrenceType: string }[],
) {
  return (
    discounts.some((discount) => discount.recurrenceType !== 'one-time' && (discount.discountPercent ?? 0) > 0) &&
    variant.asLowPrice < variant.price
  );
}

export function getRecurringAsLowPrice(
  variant: { price: number; asLowPrice: number } | undefined,
  discounts: { discountPercent?: number; recurrenceType: string }[],
) {
  return variant && shouldShowAsLowPrice(variant, discounts) ? variant.asLowPrice : undefined;
}
